import React from 'react';
import { statusLabel } from './surveyMetrics';

// The survey status options, shared by the detail header and the Overview
// market rows.
export const STATUS_OPTIONS: { value: string; label: string; disabled?: boolean }[] = [
  { value: '', label: '--Choose--', disabled: true },
  { value: 'Test', label: 'Test' },
  { value: 'Open', label: 'Live' },
  { value: 'Hold', label: 'On Hold' },
  { value: 'Wait', label: 'Ids awaited' },
  { value: 'Close', label: 'End' },
  // Selectable only by admin/super_admin (the backend enforces the same).
  { value: 'Error', label: 'Error', disabled: true },
];

type Props = {
  role: string;
  value?: string;
  onSelect: (next: string) => void;
  id?: string;
  ariaLabel?: string;
  className?: string;
};

// Sales sees plain status text; everyone else a status dropdown.
export const StatusSelect: React.FC<Props> = ({ role, value, onSelect, id, ariaLabel, className = '' }) => {
  if (role === 'sales') return <span className={className}>{statusLabel(value)}</span>;
  const isAdmin = role === 'admin' || role === 'super_admin';
  return (
    <select
      id={id}
      aria-label={ariaLabel}
      className={`form-control form-control-sm w-auto dx-status-select ${className}`.trim()}
      value={value || ''}
      onChange={(e) => onSelect(e.target.value)}
    >
      {STATUS_OPTIONS.map((o) => (
        <option key={o.value} value={o.value} disabled={o.value === 'Error' ? !isAdmin : o.disabled}>{o.label}</option>
      ))}
    </select>
  );
};
